/* eslint-disable global-require */
/* eslint-disable import/no-unresolved */
const processInclude = require('base/util');
const sequraConfiguration = require('sequra/configuration/sequraConfig');
const details = require('./product/details');
const pdpInstoreInventory = require('onestic-base/product/pdpInstoreInventory');
const instore = require('onestic-base/checkout/instore');
const productRecommendedCarousel = require('onestic-base/components/productCarousel');
const featuredProducts = require('onestic-base/components/featuredProducts');
const slickSlider = require('onestic-base/product/components/productViewSliders');
const relatedProducts = require('onestic-base/product/components/featuredProductViewCarousel');
const quantityDetail = require('onestic-base/product/components/quantityDetail');
const fullScreenGalleryZoom = require('onestic-base/product/components/fullScreenGalleryZoom');
const productRichSnippet = require('onestic-base/product/richsnippets/prodView');
const accordion = require('./components/accordion');
const quickShopping = require('./components/quickShopping').assignQuickShopping;


let prodViewDatalayer;
let categoryDatalayer;
let initialDatalayer;

if (window.dataLayer) {
    if (window.datalayerVersion === 'universal') {
        prodViewDatalayer = require('plugin-seo/universalDataLayer/layers/productView');
        categoryDatalayer = require('plugin-seo/universalDataLayer/layers/category');
    } else {
        prodViewDatalayer = require('plugin-seo/dataLayerGA4/layers/productView');
        categoryDatalayer = require('plugin-seo/dataLayerGA4/layers/category');
        initialDatalayer = require('plugin-seo/dataLayerGA4/layers/globalData');
    }
} else {
    const globalDataCode = require('plugin-seo/dataLayerGA4/layers/globalData');
    window.dataLayer = [];
    globalDataCode.sentInitConsent();
    globalDataCode.collectConsentTrackingInfo();
}

$(window).on('load', () => {
    processInclude(sequraConfiguration);
    processInclude(details);
    processInclude(pdpInstoreInventory);
    processInclude(instore);
    processInclude(productRecommendedCarousel);
    processInclude(featuredProducts);
    processInclude(slickSlider);
    processInclude(relatedProducts);
    processInclude(quantityDetail);
    processInclude(fullScreenGalleryZoom);
    processInclude(productRichSnippet);
    processInclude(accordion);
    processInclude(quickShopping);

    if (window.dataLayer) {
        if (window.datalayerVersion === 'ga4') {
            processInclude(initialDatalayer);
        }
        processInclude(prodViewDatalayer);
        processInclude(categoryDatalayer);
    }
});
